import { copyToClipboard } from '@helpers/copyToClipboard'
import { getTrimmedLabel } from '@helpers/getTrimmedLabel'
import { emitTimingToast, Tooltip } from '@ui-kit'
import { MouseEvent, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './Fields.module.scss'

export const Email = ({ email }: { email: string }) => {
  const { t } = useTranslation()

  const handleCopy = useCallback(
    async (e: MouseEvent<HTMLSpanElement>) => {
      e.stopPropagation()

      await copyToClipboard(email)

      emitTimingToast({ message: t('word.copied'), type: 'success' })
    },
    [email, t]
  )

  if (email === '-') {
    return '-'
  }

  const { trimmedLabel } = getTrimmedLabel({
    label: email,
    maxNumberOfCharacters: 35
  })

  return (
    <span className={styles.email} onClick={handleCopy}>
      <Tooltip
        content={t('copy.link.to.clipboard')}
        className={styles.email__tooltip}
      >
        {trimmedLabel}
      </Tooltip>
    </span>
  )
}
